import { getFromCommmonService } from "../apiUtils";

const baseURL = process.env.REACT_APP_API_URL
const baseURL2 = process.env.REACT_APP_CASE_AND_VISIT_API_URL

export const getCaseType = async (data) => {

  return new Promise((resolve, reject) => {
    getFromCommmonService(
      `${baseURL}Report/GetCaseTypes/?UserUid=${data.UserUid}`,
      "",
      false
    )
      .then((response) => {
        return resolve({ success: true, response: response });
      })
      .catch((error) => {
        return reject({ success: false, response: error });
      });
  });
};

export const getCaseStatus = async (data) => {

  return new Promise((resolve, reject) => {
    getFromCommmonService(
      `${baseURL2}Attorney/GetCaseStatus/?UserUid=${data.UserUid}`,
      "",
      false
    )
      .then((response) => {
        return resolve({ success: true, response: response });
      })
      .catch((error) => {
        return reject({ success: false, response: error });
      });
  });
};

export const getInsurance = async (data) => {

  return new Promise((resolve, reject) => {
    getFromCommmonService(
      `${baseURL2}Attorney/GetInsurance/?UserUid=${data.UserUid}`,
      "",
      false
    )
      .then((response) => {
        return resolve({ success: true, response: response });
      })
      .catch((error) => {
        return reject({ success: false, response: error });
      });
  });
};